import { Form } from 'react-bootstrap';

const BatchTypeSelector = ({ selectedValue, onValueChange }) => {
    return (
        <div className="d-flex align-items-center">
            <Form.Check
                type="switch"
                id="batch-type-switch"
                label={selectedValue === 'selfPick' ? 'Self Pick' : 'Team Pick'}
                checked={selectedValue === 'selfPick'}
                onChange={(e) => onValueChange(e.target.checked ? 'selfPick' : 'teamPick')}
            />
        </div>
    );
};

export default BatchTypeSelector;
